import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CalendarDaysIcon, ScissorsIcon, SproutIcon } from 'lucide-react';
import { families, products } from '../data/products';
import { ProductCard } from '../components/ProductCard';
const heroImage = 'https://cdn.magicpatterns.com/patterns/generated-images/5c5b7af9-85c0-4a32-8813-8eb55bf2d64f.jpg';
const farmerImage = 'https://cdn.magicpatterns.com/patterns/generated-images/152cb4a3-7e69-4915-99b2-6a7c4bc04be1.jpg';
const familyImages: Record<string, string> = {
  laine: 'https://cdn.magicpatterns.com/patterns/generated-images/bf62b2e8-6589-4a7f-be33-60fe9243f4bb.jpg',
  mohair: 'https://cdn.magicpatterns.com/patterns/generated-images/c6fe9112-61ce-4bd1-903f-290f426fa7c7.jpg',
  savons: 'https://cdn.magicpatterns.com/uploads/8Gd4DNGxeuie791qAe3FgQ/image3-500x428.jpg'
};
const featured = ['pelote-naturelle', 'chaussettes-mohair', 'savon-lavande', 'coffret-decouverte'];
const markets = [{
  date: 'Samedi 3 octobre',
  place: 'Marché de Millau',
  detail: '8 h — 13 h, place des Halles'
}, {
  date: 'Dimanche 18 octobre',
  place: 'Fête de la laine, Nant',
  detail: 'Stand 14, démonstration de filage'
}, {
  date: 'Samedi 7 novembre',
  place: 'Marché de Rodez',
  detail: '8 h — 13 h, place du Bourg'
}];
export function Home() {
  return <>
      <section className="relative" data-id="element-208" data-mp="2mvyw605kraej">
        <img src={heroImage} alt="Le troupeau de brebis mérinos et de chèvres angora sur le causse aveyronnais" className="h-[68vh] min-h-[420px] w-full object-cover" data-id="element-209" data-mp="2mz37rildd8f8" />
        <div className="absolute inset-0 bg-ink/45" data-id="element-210" data-mp="2d5dwe9e5zzu1" />
        <div className="absolute inset-0 flex items-end" data-id="element-211" data-mp="288vwbmts4po1">
          <div className="mx-auto w-full max-w-page px-5 pb-12 lg:px-8 lg:pb-16" data-id="element-212" data-mp="239aw792vib9q">
            <p className="text-sm text-cream/80" data-id="element-213" data-mp="2376jq2qws3xu">Causse aveyronnais · depuis 2009</p>
            <h1 className="mt-3 max-w-3xl font-display text-4xl leading-[1.08] text-cream sm:text-5xl lg:text-6xl" data-id="element-214" data-mp="1z9ik4me9tmzm">
              De la toison au savon, tout part de notre troupeau.
            </h1>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-cream/85" data-id="element-215" data-mp="1kmtncsbelnwx">
              Le GAEC Bru de la Roque élève des brebis mérinos et des chèvres angora, file sa laine et
              fabrique ses savons à la ferme. Audrey Jung vous accueille toute l’année.
            </p>
            <div className="mt-8 flex flex-wrap gap-3" data-id="element-216" data-mp="1flw6qk61l1xj">
              <Link to="/boutique" className="inline-flex items-center gap-2 rounded-full bg-cream px-5 py-3 text-sm font-medium text-ink transition-colors duration-150 ease-soft hover:bg-parchment" data-id="element-217" data-mp="23aox813wahkr">
                Découvrir la boutique
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-218" data-mp="1yk8hgaclqjv8" />
              </Link>
              <Link to="/visites" className="inline-flex items-center gap-2 rounded-full border border-cream/60 px-5 py-3 text-sm font-medium text-cream transition-colors duration-150 ease-soft hover:bg-cream/10" data-id="element-219" data-mp="2macjwee20dkn">
                Réserver une visite
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="border-b border-line bg-parchment" data-id="element-220" data-mp="akwm0x77xmjh">
        <div className="mx-auto grid max-w-page gap-8 px-5 py-10 sm:grid-cols-3 lg:px-8" data-id="element-221" data-mp="ocudlu4vyzrw">
          {[{
          icon: SproutIcon,
          title: '180 brebis & 60 chèvres',
          text: 'Pâturage tournant sur 90 ha de causse, sans engrais de synthèse.'
        }, {
          icon: ScissorsIcon,
          title: 'Filature à 40 km',
          text: 'Toisons lavées à la ferme, filées et tricotées en Aveyron.'
        }, {
          icon: CalendarDaysIcon,
          title: 'Ferme ouverte',
          text: 'Visites et ateliers du mardi au samedi, sur réservation.'
        }].map(item => <div key={item.title} className="flex gap-3" data-id="element-222" data-mp="qw9wbdirh19">
              <item.icon className="mt-0.5 h-5 w-5 shrink-0 text-olive" aria-hidden="true" data-id="element-223" data-mp="1h1i1zykxm59o" />
              <div data-id="element-224" data-mp="1c2oq2alammbm">
                <p className="font-medium text-ink" data-id="element-225" data-mp="1c36w1yxrcewq">{item.title}</p>
                <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-226" data-mp="27eoj474nroru">{item.text}</p>
              </div>
            </div>)}
        </div>
      </section>

      <section className="mx-auto max-w-page px-5 py-20 lg:px-8" data-id="element-227" data-mp="2hc2lj2tqyd15">
        <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-228" data-mp="2hahtpkyth86z">
          <h2 className="font-display text-3xl text-ink sm:text-4xl" data-id="element-229" data-mp="2mc720sunn7rd">Trois savoir-faire</h2>
          <Link to="/boutique" className="text-sm text-olive hover:text-olive-dark" data-id="element-230" data-mp="2qdivj9gngd4u">
            Voir toute la boutique →
          </Link>
        </div>
        <div className="mt-8 grid gap-6 md:grid-cols-3" data-id="element-231" data-mp="2v9heuin4f4ye">
          {families.map(family => <Link key={family.id} to={`/boutique?famille=${family.id}`} className="group flex flex-col overflow-hidden rounded-lg bg-parchment transition-colors duration-200 ease-soft hover:bg-line/50" data-id="element-232" data-mp="304n8k3mrlnx1">
              <img src={familyImages[family.id]} alt={family.label} className="aspect-[5/4] w-full object-cover transition-transform duration-300 ease-soft group-hover:scale-[1.03]" loading="lazy" data-id="element-233" data-mp="3e3d4vh1rfjkc" />
              <div className="flex flex-1 flex-col p-5" data-id="element-234" data-mp="tds2pyl12a98">
                <h3 className="font-display text-xl text-ink" data-id="element-235" data-mp="tgebg1jnmvt1">{family.label}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-236" data-mp="ogryzubnhjla">{family.blurb}</p>
                <span className="mt-auto pt-4 text-sm text-olive" data-id="element-237" data-mp="1m1nzf3alk260">Parcourir →</span>
              </div>
            </Link>)}
        </div>
      </section>

      <section className="bg-parchment" data-id="element-238" data-mp="1ccmhh7khrape">
        <div className="mx-auto grid max-w-page items-center gap-10 px-5 py-20 lg:grid-cols-[1fr_1.1fr] lg:px-8" data-id="element-239" data-mp="1cbl7l6f7ou99">
          <img src={farmerImage} alt="Audrey Jung dans la bergerie, une toison dans les mains" className="aspect-[3/4] w-full rounded-lg object-cover lg:max-w-md" loading="lazy" data-id="element-240" data-mp="17bysssjqj5yc" />
          <div data-id="element-241" data-mp="3uaub5v8dgrg0">
            <h2 className="font-display text-3xl leading-tight text-ink sm:text-4xl" data-id="element-242" data-mp="3uac9uk6urn18">
              « Une toison, ça se trie mèche par mèche. C’est là que tout se joue. »
            </h2>
            <p className="mt-6 text-base leading-relaxed text-muted" data-id="element-243" data-mp="3klavszjvbfpw">
              Audrey Jung a repris la ferme familiale en 2009 et y a introduit les chèvres angora dix ans
              plus tard. Aujourd’hui, chaque tonte est triée à la main, lavée à l’eau de source du causse,
              puis confiée à une filature aveyronnaise. Le gras récupéré au lavage devient la lanoline de
              nos savons : rien ne se perd.
            </p>
            <Link to="/la-ferme" className="mt-7 inline-flex items-center gap-2 rounded-full border border-ink px-5 py-3 text-sm font-medium text-ink transition-colors duration-150 ease-soft hover:bg-ink hover:text-cream" data-id="element-244" data-mp="31nri3imgt8x5">
              Découvrir la ferme
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-245" data-mp="14sve6ocsp9vl" />
            </Link>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-page px-5 py-20 lg:px-8" data-id="element-246" data-mp="19ygydf77l7xv">
        <h2 className="font-display text-3xl text-ink sm:text-4xl" data-id="element-247" data-mp="1a0bmf2ds1g66">Les incontournables</h2>
        <div className="mt-8 grid gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-248" data-mp="1nrgi5te0xob8">
          {featured.map(id => {
          const product = products.find(item => item.id === id);
          return product ? <ProductCard key={id} product={product} data-id="element-249" data-mp="1xm8ektvve54f" /> : null;
        })}
        </div>
      </section>

      <section className="mx-auto max-w-page px-5 pb-8 lg:px-8" data-id="element-250" data-mp="1soqabgssse2r">
        <div className="rounded-lg border border-line p-8 sm:p-10" data-id="element-251" data-mp="26nq390ncff4q">
          <div className="flex flex-wrap items-baseline justify-between gap-3" data-id="element-252" data-mp="22nflyru3p2ak">
            <h2 className="font-display text-2xl text-ink" data-id="element-253" data-mp="22lbl6iri0jei">Où nous rencontrer</h2>
            <Link to="/contact" className="text-sm text-olive hover:text-olive-dark" data-id="element-254" data-mp="cct3wzubczoz">
              Nous écrire →
            </Link>
          </div>
          <ul className="mt-6 divide-y divide-line" data-id="element-255" data-mp="wul5s29w1sll">
            {markets.map(market => <li key={market.date} className="flex flex-wrap items-baseline gap-x-6 gap-y-1 py-4" data-id="element-256" data-mp="11smoun7bdrx2">
                <span className="w-44 shrink-0 text-sm text-muted" data-id="element-257" data-mp="16jcy4biv2ex1">{market.date}</span>
                <span className="font-medium text-ink" data-id="element-258" data-mp="1al86fzz7lskb">{market.place}</span>
                <span className="text-sm text-muted" data-id="element-259" data-mp="1anaw2iwg9joi">{market.detail}</span>
              </li>)}
          </ul>
        </div>
      </section>
    </>;
}